import { render, staticRenderFns } from "./VatManagement.vue?vue&type=template&id=b59304a8&scoped=true"
import script from "./VatManagement.vue?vue&type=script&lang=js"
export * from "./VatManagement.vue?vue&type=script&lang=js"
import style0 from "./VatManagement.vue?vue&type=style&index=0&id=b59304a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59304a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b59304a8')) {
      api.createRecord('b59304a8', component.options)
    } else {
      api.reload('b59304a8', component.options)
    }
    module.hot.accept("./VatManagement.vue?vue&type=template&id=b59304a8&scoped=true", function () {
      api.rerender('b59304a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/VatManagement.vue"
export default component.exports